// Actions
export const SET_BACK_VISIBLE = "SET_BACK_VISIBLE";

// Statut initial
export const INITIAL_STATE = {
  backVisible: false
};

